// src/features/rrhh/mensajeria/api/reclamosApi.js
import httpClient from "../../../../shared/api/httpClient";
import { qs } from "../../../../shared/api/qs";

function getLicenseIdOrThrow() {
  try {
    const v = localStorage.getItem("sabi_empresa_id");
    if (!v) throw new Error();
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0) throw new Error();
    return n;
  } catch {
    throw new Error("No se encontró sabi_empresa_id en localStorage (license requerida).");
  }
}

function getCurrentUserIdOrThrow() {
  try {
    const raw = localStorage.getItem("sabi_user");
    if (!raw) throw new Error();
    const user = JSON.parse(raw);
    const id = Number(user?.id);
    if (!Number.isFinite(id) || id <= 0) throw new Error();
    return id;
  } catch {
    throw new Error("No se encontró sabi_user.id en localStorage.");
  }
}

/**
 * LISTAR RECLAMOS (WEB)
 * GET /hr/areas/messaging/licenses/:licenseId/complaints
 */
export const listarReclamos = (filters = {}) => {
  const licenseId = getLicenseIdOrThrow();

  const query = qs({
    branchId: filters.branchId ?? filters.sucursal_id,
    areaId: filters.areaId ?? filters.area_id,
    state: filters.state ?? filters.estado,
    priority: filters.priority ?? filters.prioridad,
    q: filters.q,
    limit: filters.limit ?? 200,
    offset: filters.offset ?? 0,
  });

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/complaints${query}`
  );
};

export const obtenerReclamo = (complaintId) => {
  const licenseId = getLicenseIdOrThrow();
  if (!complaintId) throw new Error("complaintId es requerido");

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/complaints/${complaintId}`
  );
};

export const listarRespuestasReclamo = (complaintId) => {
  const licenseId = getLicenseIdOrThrow();
  if (!complaintId) throw new Error("complaintId es requerido");

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/complaints/${complaintId}/responses`
  );
};

export const listarHistorialReclamo = (complaintId) => {
  const licenseId = getLicenseIdOrThrow();
  if (!complaintId) throw new Error("complaintId es requerido");

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/complaints/${complaintId}/history`
  );
};

export const listarTimelineReclamo = (complaintId) => {
  const licenseId = getLicenseIdOrThrow();
  if (!complaintId) throw new Error("complaintId es requerido");

  return httpClient.get(
    `/hr/areas/messaging/licenses/${licenseId}/complaints/${complaintId}/timeline`
  );
};

export const responderReclamo = (complaintId, data) => {
  const licenseId = getLicenseIdOrThrow();
  const authorUserId = data?.authorUserId ?? getCurrentUserIdOrThrow();
  const message = data?.message ?? data?.mensaje;
  const visibleToEmployee =
    data?.visibleToEmployee !== undefined
      ? data.visibleToEmployee
      : data?.visible_empleado !== undefined
      ? data.visible_empleado
      : true;

  if (!complaintId) throw new Error("complaintId / reclamoId es requerido");
  if (!message) throw new Error("data.message / data.mensaje es requerido");

  return httpClient.post(
    `/hr/areas/messaging/licenses/${licenseId}/complaints/${complaintId}/responses`,
    { authorUserId, message, visibleToEmployee }
  );
};

export const cambiarEstadoReclamo = (complaintId, data) => {
  const licenseId = getLicenseIdOrThrow();
  const changedByUserId = data?.changedByUserId ?? getCurrentUserIdOrThrow();
  const newState = data?.newState ?? data?.estado_nuevo;
  const comment =
    data?.comment !== undefined
      ? data.comment
      : data?.comentario !== undefined
      ? data.comentario
      : null;

  if (!complaintId) throw new Error("complaintId / reclamoId es requerido");
  if (!newState) throw new Error("data.newState / data.estado_nuevo es requerido");

  return httpClient.post(
    `/hr/areas/messaging/licenses/${licenseId}/complaints/${complaintId}/state`,
    { newState, changedByUserId, comment }
  );
};